import React from "react";

function TestFlightDownload() {
  return (
    <div className="min-h-screen bg-sky-50 py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl font-extrabold mb-8 tracking-tight">
          Download Intuuch
        </h1> {/*Join the Patch Private Beta 🚀

        <p className="text-lg text-gray-700 mb-6 leading-relaxed">
          Welcome! 🎉 You’re part of a select group of students getting exclusive early access to Patch. Follow the simple steps below to start connecting with friends on campus.
        </p>*/}

        {/*
        <p className="text-gray-700 mb-10">
          <strong>Note:</strong> TestFlight is only available for <strong>iOS devices</strong>. If you’re on Android, you can join our waitlist to be the first to access Patch when it’s ready for your device.
        </p>*/}


        <p className="text-lg text-gray-700 mb-6 leading-relaxed">
          Welcome to the <strong>Intuuch Private Beta</strong>! ✉️ You’re part of a select group of students getting early access to the app. Follow the simple steps below to get started and start connecting with friends.
        </p>

        <p className="text-gray-700 mb-10">
          <strong>Note:</strong> TestFlight is only available for <strong>iOS devices</strong>. If you’re on Android, you can join our waitlist below to be the first to know when the Android version is ready.
        </p>


        <section className="space-y-12 text-gray-700">
{/*}
<div className="flex flex-col items-center space-y-8 my-12">
  <img src="/images/preview1.png" alt="Patch Preview 1" className="w-11/12 max-w-2xl" />
  <img src="/images/preview2.png" alt="Patch Preview 2" className="w-11/12 max-w-2xl" />
  <img src="/images/preview3.png" alt="Patch Preview 3" className="w-11/12 max-w-2xl" />
</div>*/}


        <div className="grid grid-cols-1 sm:grid-cols-3 my-12">
        <img src="/images/preview1.png" alt="Patch Screen 1"  />
        <img src="/images/preview2.png" alt="Patch Screen 2"  />
        <img src="/images/preview3.png" alt="Patch Screen 3"  />
        </div>
        {/*<p className="text-center text-gray-600 mb-12">A sneak peek at Patch in action!</p>

        <p className="text-center text-gray-600 mb-12">A sneak peek at what Patch looks like!</p>*/}

          {/* Step 1 */}
          <div>
            <h2 className="text-2xl font-bold mb-4">Step 1: Install TestFlight</h2>
            <p className="mb-2">
              If you don’t already have TestFlight on your iOS device, download it from the App Store:
            </p>
            <a
              href="https://apps.apple.com/us/app/testflight/id899247664"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 bg-cyan-600 text-white rounded-2xl font-semibold hover:bg-cyan-700 transition-colors"
            >
              Download TestFlight
            </a>
          </div>

          {/* Step 2 */}
          <div>
            <h2 className="text-2xl font-bold mb-4">Step 2: Install Intuuch</h2>
            <p className="mb-2">
             Click the link below to install the Intuuch Beta via TestFlight. This will give you access to the latest version of our app on iOS.            </p>
            <a
              href="https://testflight.apple.com/join/murjgrp7" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 bg-cyan-600 text-white rounded-2xl font-semibold hover:bg-cyan-700 transition-colors mt-4"
            >
              Install Intuuch Beta
            </a>
          </div>

          {/* Step 3  . Have fun exploring, and don’t forget to share your thoughts — your feedback helps make Intuuch even better!*/}
          <div>
            <h2 className="text-2xl font-bold mb-4">Step 3: Start Exploring! ✨</h2>
            <p>
              Open the Intuuch app, sign in, and start connecting with friends on campus!
            </p>
          </div>

          {/* Android Waitlist */}
          <div className="mt-6">
            <h2 className="text-2xl font-bold mb-4">Android Users</h2>
            <p className="mb-2">
              If you’re on Android, you can join our waitlist to be the first to access Intuuch when the Android version launches!
            </p>
            <a
              href="https://forms.gle/CFhYeRzvb45XXA7d7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 bg-cyan-600 text-white rounded-2xl font-semibold hover:bg-cyan-700 transition-colors"
            >
              Join Android Waitlist
            </a>
          </div>
        </section>

        <div className="text-center mt-12">
          <p className="text-gray-500">
            Need help? Contact us at{" "}
            <a href="mailto:hello@jyni.app" className="text-cyan-600 underline">
              hello@jyni.app
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default TestFlightDownload;
